/* url */
export const apibaseURL=(window.location.hostname==='localhost')?'/osah-public-access/':'/app/backend/public/osah-public-access/';
//export const apibaseURL=(window.location.hostname==='localhost')?'http://localhost/OSAH/agency.osah.git/backend/public/osah-agency/':'/backend/public/osah-agency/';

export const baseURL=(window.location.port)?window.location.protocol + '//' + window.location.hostname+':'+window.location.port: window.location.protocol + '//' + window.location.hostname;
export const eStoragebaseURL=baseURL+'/app/backend/public/file-storage/';

export const mediaPath = "/app/static/media/";
/* common error messages */
export const errorMessage={
    contactAdmin:"Something went wrong! Please contact your administrator.",
    tryAgain:"Something went wrong. Try again later.",
    fillRequiredFields:"Please fill all required fields.",
	authenticationFailed: "You have entered an incorrect email or password. Note that your username is an email address. Try again or reset your password or create an account.",
   
    loginAttempt: "We can't find that username and password. You can reset your password or try again.(Please note, your account will be locked after 4 incorrect attempts.)",
    lockedAcc:"You have too many failed attempts to login. Your account is temporarily locked. Please wait 2 hours before attempting to login again.",
    
}

/* constants used for User Actions and Reducers */
export const LOGIN_SUCCESS='LOGIN_SUCCESS'
export const LOGIN_FAILED='LOGIN_FAILED'
export const LOGOUT='LOGOUT'
export const EMAIL_SENT='EMAIL_SENT'
export const NOTIFICATION_MODAL='NOTIFICATION_MODAL'

/* constants used for UI Actions and Reducers */
export const SHOW_LOADER='SHOW_LOADER'
export const HIDE_LOADER='HIDE_LOADER'
export const SHOW_NOTIFICATION='SHOW_NOTIFICATION'

export const SET_DOCKET_DATA='SET_DOCKET_DATA'
export const SET_DOCKET_GENERAL_INFO='SET_DOCKET_GENERAL_INFO'
export const SET_PARTY_INFO='SET_PARTY_INFO'
export const SET_DOCUMENT_TYPES='SET_DOCUMENT_TYPES'
export const SET_DOCKETS='SET_DOCKETS'
export const SET_REJECTED_PENDING_TYPES='SET_REJECTED_PENDING_TYPES'
export const MODAL='MODAL'
export const THANK_YOU_MODAL='THANK_YOU_MODAL'
export const SET_DOCKET_STATUS='SET_DOCKET_STATUS'
export const SET_USER_DATA='SET_USER_DATA'
export const USER_PASSWORD='USER_PASSWORD'
export const RESET_DOCKET_DATA='RESET_DOCKET_DATA'
export const SET_DOCUMENT_ACTIVITY_DATA='SET_DOCUMENT_ACTIVITY_DATA'
export const SET_DOCUMENT_PREVIEW_DATA='SET_DOCUMENT_PREVIEW_DATA'

export const S1='i4hh5yNd'
export const S2='EZMHfV0X'
export const S3='nMoDQ1d5'
export const S4='7aT6vrx5'

/* constants used for Form1 Actions and Reducers */
// export const SET_FORM1_DATA='SET_FORM1_DATA'
